import React, { useState, useRef } from 'react';
import axios from 'axios';
import { getCookie } from '../../helpers/cookie';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Avatar } from 'primereact/avatar';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { FileUpload } from 'primereact/fileupload';

// PrimeReact CSS imports
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

const customStyles = `
    .p-dialog-content {
        padding: 1.5rem !important;
    }

    .icon-picker-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(3rem, 1fr));
        gap: 0.75rem;
        padding: 0.75rem;
        border: 1px solid var(--surface-border);
        border-radius: var(--border-radius);
        background-color: var(--surface-100);
    }

    .icon-picker-item {
        width: 3rem;
        height: 3rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: var(--border-radius);
        cursor: pointer;
        transition: background-color 0.2s, border-color 0.2s;
    }

    .icon-picker-item:hover {
        background-color: var(--surface-200);
    }

    .icon-picker-item.selected {
        border: 2px solid var(--primary-color) !important;
        background-color: var(--primary-color-light);
    }

    .p-dialog-footer {
        padding: 1rem 1.5rem !important;
        border-top: 1px solid var(--surface-border);
        background-color: var(--surface-0);
    }

    .work-type-modal .field {
        margin-bottom: 1rem;
    }

    .work-type-modal .field:last-child {
        margin-bottom: 0;
    }

    .p-fileupload-buttonbar .p-button {
        padding: 0.5rem 1rem;
        font-size: 0.875rem;
    }

    .icon-upload-area {
        border: 2px dashed var(--surface-border);
        border-radius: var(--border-radius);
        padding: 2rem;
        text-align: center;
        cursor: pointer;
        transition: background-color 0.2s;
        background-color: var(--surface-50);
    }

    .icon-upload-area:hover {
        background-color: var(--surface-100);
    }

    .icon-upload-area .p-fileupload-buttonbar {
        background: none;
        border: none;
        padding: 0;
    }

    .icon-upload-area .p-fileupload-content {
        display: none;
    }

    /* Styling for the dropdown separator and items */
    .dropdown-divider {
        border-top: 3px solid #666 !important;
        margin: 8px 0 !important;
        padding: 0 !important;
        height: 0 !important;
        width: 100% !important;
        display: block !important;
        pointer-events: none !important;
        background-color: transparent !important;
    }
    
    .action-item-add {
        color: inherit;
        padding-top: 4px;
        padding-bottom: 4px;
    }

    /* Make dropdown icons smaller */
    .work-type-icon {
        font-size: 1rem !important;
    }
    
    .work-type-icon-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.5rem;
        height: 1.5rem;
    }`;

const WorkType1 = ({
    initialWorkTypes: propInitialWorkTypes,
    dropdownWorkTypes: propDropdownWorkTypes,
    onWorkTypesChange,
    onSelectionChange,
    selectedWorkType: propSelectedWorkType,
    lookupField, // optional prop to decide lookup name
    propLookupOptions, // optional dynamic lookup options
    propLookupInitials, // optional dynamic initial lists per lookup
    // New props for external lookup modal
    onSentinelSelect, // function to handle sentinel selection (add/edit)
    useExternalModal = false // flag to use external modal instead of built-in
} = {}) => {
    const [workTypeModalVisible, setWorkTypeModalVisible] = useState(false);
    const [iconPickerVisible, setIconPickerVisible] = useState(false);
    const toast = useRef(null);
    console.log(propSelectedWorkType,'propSelectedWorkType');
    
    // Use prop if available, else fallback to default
    const initialWorkTypes = propInitialWorkTypes || [
        {
            name: 'AI Generator',
            color: '#4c9aff',
            id: 'task',
            statuses: [
                'To Do', 'In Progress', 'In Review', 'Ready for QA', 'QA in Progress', 'Blocked', 'Done or Closed'
            ]
        },
        {
            name: 'Resume Parser',
            color: '#ff5630',
            id: 'bug',
            statuses: [
                'Open', 'Triaged', 'In Progress', 'Ready for QA', 'QA in Progress', 'Reopened', 'Blocked', 'Closed', "Won't Fix", 'Duplicate'
            ]
        },
        {
            name: 'Chatbot Assistant',
            color: '#36b37e',
            id: 'story',
            statuses: ['To Do', 'In Progress', 'Done']
        },
    ];

    const [workTypes, setWorkTypes] = useState(initialWorkTypes || []);

    const [formData, setFormData] = useState(() => {
        const defaultWorkType = (initialWorkTypes || []).find(wt => wt.id === 'task') || workTypes[0];

        const defaultStatus = defaultWorkType?.statuses && defaultWorkType.statuses.length > 0
            ? defaultWorkType.statuses[0]
            : null;

        return {
            workType: defaultWorkType || null,
            status: defaultStatus,
        };
    });


    const [workTypeForm, setWorkTypeForm] = useState({
        name: '',
        icon: '',
        color: '#4c9aff',
        description: '',
        statuses: ['To Do', 'In Progress', 'Done']
    });

    // store the active lookup name to use in payload (if the component is used for different lookup contexts)
    const [currentLookupName, setCurrentLookupName] = useState(null);
    const [selectedLookupName, setSelectedLookupName] = useState(null);

    // options for lookup target selector shown in modal
    const lookupOptions = propLookupOptions || [
        { label: 'Designation', value: 'employee_designation' },
        { label: 'Categories', value: 'employee_categories' },
        { label: 'Group', value: 'employee_group' },
        { label: 'Employee Type', value: 'employee_employeeType' },
        { label: 'Department', value: 'employee_department' },
        { label: 'Work Location', value: 'employee_workLocation' },
        { label: 'Employee Status', value: 'employee_employeeStatus' },
        { label: 'Shift Timings', value: 'employee_shiftTimings' },
        { label: 'Sub Department', value: 'employee_subDepartment' }
    ];

    // Map lookup target -> sensible initial workTypes for that lookup.
    // These are used only when parent doesn't supply `propInitialWorkTypes`.
    const lookupInitials = propLookupInitials || {};

    const [editingWorkType, setEditingWorkType] = useState(null);
    const [errors, setErrors] = useState({});
    const [file, setFile] = useState(null); // Add missing file state

    const colors = [
        '#4c9aff', '#ff5630', '#36b37e', '#ffab00',
        '#6554c0', '#ff8b00', '#00875a', '#de350b',
        '#00b8d9', '#663399', '#ff9900', '#3366ff'
    ];

    const predefinedIcons = [
        { value: 'pi pi-check-square', color: colors[0] },
        { value: 'pi pi-exclamation-circle', color: colors[1] }, // Add back bug icon
        { value: 'pi pi-book', color: colors[2] },
        { value: 'pi pi-sitemap', color: colors[3] },
        { value: 'pi pi-home', color: colors[4] },
        { value: 'pi pi-cog', color: colors[5] },
        { value: 'pi pi-search', color: colors[6] },
        { value: 'pi pi-user', color: colors[7] },
        { value: 'pi pi-users', color: colors[8] },
        { value: 'pi pi-bell', color: colors[9] },
        { value: 'pi pi-envelope', color: colors[10] },
        { value: 'pi pi-briefcase', color: colors[11] },
        { value: 'pi pi-calendar', color: colors[0] },
        { value: 'pi pi-clock', color: colors[1] },
        { value: 'pi pi-globe', color: colors[2] },
        { value: 'pi pi-map-marker', color: colors[3] },
        { value: 'pi pi-info-circle', color: colors[4] },
        { value: 'pi pi-question-circle', color: colors[5] },
        { value: 'pi pi-exclamation-triangle', color: colors[6] },
        { value: 'pi pi-check-circle', color: colors[7] },
        { value: 'pi pi-times-circle', color: colors[8] },
        { value: 'pi pi-ban', color: colors[9] },
        { value: 'pi pi-filter', color: colors[10] },
        { value: 'pi pi-print', color: colors[11] },
        { value: 'pi pi-share-alt', color: colors[0] },
        { value: 'pi pi-link', color: colors[1] },
        { value: 'pi pi-paperclip', color: colors[2] },
        { value: 'pi pi-save', color: colors[3] },
        { value: 'pi pi-pencil', color: colors[4] },
        { value: 'pi pi-copy', color: colors[5] },
        { value: 'pi pi-trash', color: colors[6] },
        { value: 'pi pi-list', color: colors[7] },
        { value: 'pi pi-bars', color: colors[8] },
        { value: 'pi pi-table', color: colors[9] },
        { value: 'pi pi-id-card', color: colors[10] },
        { value: 'pi pi-plus', color: colors[11] },
        { value: 'pi pi-minus', color: colors[0] },
        { value: 'pi pi-check', color: colors[1] },
        { value: 'pi pi-times', color: colors[2] },
        { value: 'pi pi-refresh', color: colors[3] },
        { value: 'pi pi-sync', color: colors[4] },
        { value: 'pi pi-undo', color: colors[5] },
        { value: 'pi pi-download', color: colors[6] },
        { value: 'pi pi-upload', color: colors[7] },
        { value: 'pi pi-sign-in', color: colors[8] },
        { value: 'pi pi-sign-out', color: colors[9] },
        { value: 'pi pi-lock', color: colors[10] },
        { value: 'pi pi-unlock', color: colors[11] },
        { value: 'pi pi-eye', color: colors[0] },
        { value: 'pi pi-eye-slash', color: colors[1] },
        { value: 'pi pi-star', color: colors[2] },
        { value: 'pi pi-star-fill', color: colors[3] },
        { value: 'pi pi-heart', color: colors[4] },
        { value: 'pi pi-flag', color: colors[5] },
        { value: 'pi pi-folder', color: colors[6] },
        { value: 'pi pi-folder-open', color: colors[7] },
        { value: 'pi pi-file', color: colors[8] },
        { value: 'pi pi-image', color: colors[9] },
        { value: 'pi pi-camera', color: colors[10] },
        { value: 'pi pi-tag', color: colors[11] },
        { value: 'pi pi-bookmark', color: colors[0] },
        { value: 'pi pi-ticket', color: colors[1] },
        { value: 'pi pi-palette', color: colors[2] },
        { value: 'pi pi-key', color: colors[3] },
        { value: 'pi pi-shield', color: colors[4] },
        { value: 'pi pi-bolt', color: colors[5] },
        { value: 'pi pi-comment', color: colors[6] },
        { value: 'pi pi-comments', color: colors[7] },
        { value: 'pi pi-send', color: colors[8] },
        { value: 'pi pi-mobile', color: colors[9] },
        { value: 'pi pi-phone', color: colors[10] },
        { value: 'pi pi-play', color: colors[11] },
        { value: 'pi pi-pause', color: colors[0] },
        { value: 'pi pi-stop', color: colors[1] },
        { value: 'pi pi-volume-up', color: colors[2] },
        { value: 'pi pi-microphone', color: colors[3] },
        { value: 'pi pi-chart-bar', color: colors[4] },
        { value: 'pi pi-chart-line', color: colors[5] },
        { value: 'pi pi-server', color: colors[6] },
        { value: 'pi pi-database', color: colors[7] },
        { value: 'pi pi-cloud', color: colors[8] },
        { value: 'pi pi-arrow-up', color: colors[9] },
        { value: 'pi pi-arrow-down', color: colors[10] },
        { value: 'pi pi-arrow-left', color: colors[11] },
        { value: 'pi pi-arrow-right', color: colors[0] },
        { value: 'pi pi-angle-up', color: colors[1] },
        { value: 'pi pi-angle-down', color: colors[2] },
        { value: 'pi pi-angle-left', color: colors[3] },
        { value: 'pi pi-angle-right', color: colors[4] },
        { value: 'pi pi-exclamation-circle', color: colors[5] },
        { value: 'pi pi-thumbs-down', color: colors[6] },
        { value: 'pi pi-wrench', color: colors[7] },
        { value: 'pi pi-code', color: colors[8] },
        { value: 'T', color: colors[9] },
        { value: 'B', color: colors[10] },
        { value: 'S', color: colors[11] },
        { value: 'E', color: colors[0] },
        { value: 'P', color: colors[1] },
        { value: 'D', color: colors[2] },
        { value: 'I', color: colors[3] }
    ];

    // Modify the workTypeOptionTemplate function
    const workTypeOptionTemplate = (option) => {
        if (!option) {
            let labelText = '';
            if (!propSelectedWorkType) {
                labelText = '';
            } else if (typeof propSelectedWorkType === 'string') {
                labelText = propSelectedWorkType;
            } else if (typeof propSelectedWorkType === 'object') {
                labelText = propSelectedWorkType.name || propSelectedWorkType.label || propSelectedWorkType.value || '';
            } else {
                labelText = String(propSelectedWorkType);
            }
            return <span>Select {labelText}</span>;
        }

        // Special divider item - make it truly just a line with no behavior
        if (option.id === 'divider') {
            // Return a div with border styling instead of hr
            return (
                <div
                    className='border-t border-gray-200'
                ></div>
            );
        }

        // Safety check: ensure option.id is a string before using startsWith
        const optionId = String(option.id || '');

        if (optionId.startsWith('create-new-')) {
                return (
                    <div className="flex align-items-center gap-2 action-item-add">
                        <i className="pi pi-plus work-type-icon"></i>
                        <span>{option.name || 'Add'}</span>
                    </div>
                );
        }

        if (optionId.startsWith('edit-selected-')) {
                return (
                    <div className="flex align-items-center gap-2 action-item-edit">
                        <i className="pi pi-pencil work-type-icon"></i>
                        <span>{option.name || 'Edit'}</span>
                    </div>
                );
        }

        return (
            <div className="flex align-items-center gap-2">
                {option.icon && (
                    <div className="work-type-icon-container">
                        <i className={`${option.icon} work-type-icon`} style={{ color: option.color }}></i>
                    </div>
                )}
                <span>{option.name}</span>
            </div>
        );
    };

    // Keep internal workTypes in sync if parent provides updated initialWorkTypes
    React.useEffect(() => {
        if (propInitialWorkTypes && Array.isArray(propInitialWorkTypes)) {
            setWorkTypes(propInitialWorkTypes);
        }
    }, [propInitialWorkTypes]);

    // When selected lookup changes (either by prop, lookupField or modal selection),
    // set sensible defaults for workTypes if parent did not provide propInitialWorkTypes.
    React.useEffect(() => {
        // prefer explicit selectedLookupName -> currentLookupName -> lookupField
        const key = selectedLookupName || currentLookupName || lookupField || null;
        if (!propInitialWorkTypes && key) {
            const mapped = lookupInitials[key];
            if (mapped && Array.isArray(mapped)) {
                setWorkTypes(mapped);
                // also ensure formData.workType picks first entry if not set
                setFormData(prev => ({ ...prev, workType: mapped[0] || null, status: (mapped[0] && mapped[0].statuses && mapped[0].statuses[0]) || null }));
            }
        }
    }, [selectedLookupName, currentLookupName, lookupField, propInitialWorkTypes]);

    // If parent passes a selected work type, set it as the current selection
    React.useEffect(() => {
        // If lookupField is 'company', set selectedWorkType to empty/null
        // if (lookupField === 'company') {
        //     setFormData(prev => ({ ...prev, workType: null }));
        //     return;
        // }

        if (propSelectedWorkType) {
            // propSelectedWorkType may be an object or a primitive. If it's an object,
            // prefer to set the full object if it has an id, otherwise try to map by name.
            if (typeof propSelectedWorkType === 'object') {
                // if it already looks like a workType object, use it
                if (propSelectedWorkType.id !== undefined) {
                    setFormData(prev => ({ ...prev, workType: propSelectedWorkType }));
                } else {
                    // try to find matching workType in current list by name
                    const match = workTypes.find(wt => String(wt.name).toLowerCase() === String(propSelectedWorkType.name || propSelectedWorkType.value || '').toLowerCase());
                    setFormData(prev => ({ ...prev, workType: match || propSelectedWorkType }));
                }
            } else {
                // primitive (id or name) - try to find by id or name
                const matchById = workTypes.find(wt => String(wt.id) === String(propSelectedWorkType));
                const matchByName = workTypes.find(wt => String(wt.name).toLowerCase() === String(propSelectedWorkType).toLowerCase());
                setFormData(prev => ({ ...prev, workType: matchById || matchByName || propSelectedWorkType }));
            }
        }
    }, [propSelectedWorkType, lookupField]);

    // If parent passes a label like 'Designation' or 'Work Type' via propSelectedWorkType,
    // try to map it to the correct lookup name and set lookup defaults.
    React.useEffect(() => {
        if (!propSelectedWorkType) return;
        try {
            const raw = String(propSelectedWorkType).trim();
            const labelMap = {
                'Designation': 'employee_designation',
                'Categories': 'employee_categories',
                'Group': 'employee_group',
                'Employee Type': 'employee_employeeType',
                'Department': 'employee_department',
                'Work Location': 'employee_workLocation',
                'Employee Status': 'employee_employeeStatus',
                'Shift Timings': 'employee_shiftTimings',
                'Work Type': 'work_type_document'
            };

            if (labelMap[raw]) {
                setCurrentLookupName(labelMap[raw]);
                setSelectedLookupName(labelMap[raw]);
            } else if (raw.startsWith('employee_')) {
                setCurrentLookupName(raw);
                setSelectedLookupName(raw);
            } else if (raw.toLowerCase().includes('work') && raw.toLowerCase().includes('type')) {
                setCurrentLookupName('work_type_document');
                setSelectedLookupName('work_type_document');
            } else {
                // fallback: convert spaces to underscores
                const conv = raw.replace(/\s+/g, '_').toLowerCase();
                setCurrentLookupName(conv);
                setSelectedLookupName(conv);
            }
        } catch (e) {
            // ignore mapping errors
        }
    }, [propSelectedWorkType]);

    const saveWorkType = async () => {
        if (!workTypeForm.name.trim()) {
            toast.current.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Name is required'
            });
            return;
        }

        const token = getCookie('access_token') || getCookie('authToken');
        // Determine lookup name from selected field
        const getLookupName = (field) => {
            const map = {
                categories: 'employee_categories',
                group: 'employee_group',
                designation: 'employee_designation',
                employeeType: 'employee_employeeType',
                department: 'employee_department',
                workLocation: 'employee_workLocation',
                employeeStatus: 'employee_employeeStatus',
                shiftTimings: 'employee_shiftTimings'
            };

            if (!field) return 'work_type_document';

            // allow either exact key or flexible values like 'categories' or 'employee_categories'
            if (map[field]) return map[field];
            if (Object.values(map).includes(field)) return field;

            // fallback to provided string
            return field;
        };

        // Determine final lookup name: prefer explicit selectedLookupName, then currentLookupName, then prop lookupField, then try to infer from editingWorkType
    const inferredFromEditing = editingWorkType && typeof editingWorkType.name === 'string' && editingWorkType.name.startsWith('employee_') ? editingWorkType.name : null;
    const resolvedField = selectedLookupName || currentLookupName || lookupField || inferredFromEditing;
    const lookupName = getLookupName(resolvedField);

        // Build lookup payload as required by the API
        const payload = {
            name: lookupName,
            value: workTypeForm.name,
            description: workTypeForm.description || '',
            type: workTypeForm.description || workTypeForm.name
        };

        let updatedWorkTypes;

        try {
            if (editingWorkType) {
                const url = `${process.env.REACT_APP_Company_Contact}/company/lookups/${editingWorkType.id}/`;
                const res = await axios.patch(url, payload, { headers: { Authorization: `Bearer ${token}` } });
                const updated = res && res.data ? res.data : { ...payload, id: editingWorkType.id };

                // Map/update the local workTypes list: try to preserve full object if API returns only lookup entry
                updatedWorkTypes = workTypes.map(wt => wt.id === editingWorkType.id ? { ...wt, name: updated.value || updated.name || wt.name, description: updated.description || wt.description } : wt);
                setWorkTypes(updatedWorkTypes);

                setFormData(prev => ({ ...prev, workType: updated }));

                if (onSelectionChange) onSelectionChange(updated);

                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Work type updated successfully!' });
            } else {
                const url = `${process.env.REACT_APP_Company_Contact}/company/lookups/`;
                const res = await axios.post(url, payload, { headers: { Authorization: `Bearer ${token}` } });
                const created = res && res.data ? res.data : { ...payload, id: Date.now().toString() };

                // Try to build a local work type entry from created lookup
                const localCreated = { id: created.id || Date.now().toString(), name: created.value || created.name || payload.value, description: created.description || payload.description, icon: workTypeForm.icon, color: workTypeForm.color, statuses: workTypeForm.statuses || ['To Do', 'In Progress', 'Done'] };

                updatedWorkTypes = [...workTypes, localCreated];
                setWorkTypes(updatedWorkTypes);

                setFormData(prev => ({ ...prev, workType: localCreated, status: localCreated.statuses ? localCreated.statuses[0] : null }));

                if (onSelectionChange) onSelectionChange(localCreated);

                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Work type created successfully!' });
            }

            if (onWorkTypesChange) onWorkTypesChange(updatedWorkTypes);
            setWorkTypeModalVisible(false);
        } catch (err) {
            console.error('WorkType save error', err);
            toast.current.show({ severity: 'error', summary: 'Save Failed', detail: err?.response?.data?.message || 'Could not save work type' });
        }
    };

    const deleteWorkType = (workType) => {
        confirmDialog({
            message: `Are you sure you want to delete "${workType.name}" work type?`,
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                if (workTypes.length <= 1) {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Warning',
                        detail: 'Cannot delete the last work type'
                    });
                    return;
                }

                const updatedWorkTypes = workTypes.filter(wt => wt.id !== workType.id);
                setWorkTypes(updatedWorkTypes);

                if (formData.workType.id === workType.id) {
                    const newDefaultWorkType = updatedWorkTypes[0];
                    setFormData(prev => ({
                        ...prev,
                        workType: newDefaultWorkType,
                        status: newDefaultWorkType ? newDefaultWorkType.statuses[0] : null
                    }));

                    // Notify parent of selection change
                    if (onSelectionChange) {
                        onSelectionChange(newDefaultWorkType);
                    }
                }

                // Notify parent of work types change
                if (onWorkTypesChange) {
                    onWorkTypesChange(updatedWorkTypes);
                }

                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Work type deleted successfully!'
                });
            }
        });
    };

    const onWorkTypeIconUpload = (event) => {
        const file = event.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setWorkTypeForm(prev => ({ ...prev, icon: e.target.result }));
                toast.current.show({
                    severity: 'success',
                    summary: 'Icon Uploaded',
                    detail: 'Image selected as icon.'
                });
            };
            reader.onerror = () => {
                toast.current.show({
                    severity: 'error',
                    summary: 'Upload Failed',
                    detail: 'Could not read the image file.'
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const selectIcon = (iconValue) => {
        setWorkTypeForm(prev => ({ ...prev, icon: iconValue }));
        setIconPickerVisible(false);
    };

    // Build per-field sentinel labels/ids for Add/Edit actions so each
    // dropdown will show context-aware actions like "Add Designation".
    const buildSentinels = () => {
        // If lookupField is null or 'company', don't show Add/Edit options
        // if (!lookupField || lookupField === 'company') {
        //     return [];
        // }

        // derive a human label and a slug used in ids
        const derive = () => {
            let human = 'Work Type';
            let slug = 'work-type';

            // prefer explicit selected lookup name (eg: 'employee_designation')
            const key = selectedLookupName || currentLookupName || lookupField;

            if (key && typeof key === 'string') {
                if (key === 'work_type_document' || key.includes('work_type')) {
                    human = 'Work Type';
                    slug = 'work-type';
                } else if (key.startsWith('employee_')) {
                    const rest = key.replace(/^employee_/, '').replace(/_/g, ' ');
                    human = rest.split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ');
                    slug = key.replace(/^employee_/, '').replace(/_/g, '-');
                } else {
                    human = key.replace(/_/g, ' ').split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(' ');
                    slug = key.replace(/_/g, '-');
                }
            } else if (propSelectedWorkType) {
                if (typeof propSelectedWorkType  === 'string') {
                    human = propSelectedWorkType;
                    slug = propSelectedWorkType.replace(/\s+/g, '-').toLowerCase();
                } else if (typeof propSelectedWorkType === 'object' && propSelectedWorkType.name) {
                    human = String(propSelectedWorkType.name);
                    slug = human.replace(/\s+/g, '-').toLowerCase();
                }
            }

            return { human, slug };
        };

        const { human, slug } = derive();
            // console.log("Derived sentinel labels:", { human, slug });
            
        return [
            { id: 'divider', disabled: true },
            { name: `Add`, id: `create-new-${slug}-type` },
            { name: `Edit`, id: `edit-selected-${slug}-type` }
        ];
    };

    const normalizeDropdown = (list) => {
        const base = Array.isArray(list) ? list.slice() : ([]);

        // Dedupe by id if present, otherwise by lowercased name.
        const seen = new Set();
        const out = [];
        for (const item of base) {
            if (!item) continue;
            const key = (item.id !== undefined && item.id !== null) ? `id:${item.id}` : `name:${String(item.name || '').toLowerCase()}`;
            if (seen.has(key)) continue;
            seen.add(key);
            // skip sentinel-like items here; we'll append canonical sentinels later
            if (item.id === 'divider' || (typeof item.id === 'string' && item.id.startsWith('create-new-')) || (typeof item.id === 'string' && item.id.startsWith('edit-selected-'))) {
                continue;
            }
            out.push(item);
        }

        // Ensure sentinel divider + actions are present exactly once at the end
        return [...out, ...buildSentinels()];
    };

    const dropdownWorkTypes = normalizeDropdown(propDropdownWorkTypes || [...workTypes]);

    const handleInputChange = (field, value) => {
  if (field === 'workType') {
    const id = value?.id; // optional chaining

    if (typeof id === 'string' && id.startsWith('create-new-')) {
      if (useExternalModal && onSentinelSelect) {
        // Use external modal
        onSentinelSelect('add', lookupField);
        setFormData(prev => ({
          ...prev,
          workType: prev.workType || (workTypes.find(wt => wt.id === 'task') || workTypes[0])
        }));
        return;
      }
      // Use built-in modal
      openCreateWorkType();
      setFormData(prev => ({
        ...prev,
        workType: prev.workType || (workTypes.find(wt => wt.id === 'task') || workTypes[0])
      }));
      return;
    }

    if (typeof id === 'string' && id.startsWith('edit-selected-')) {
      if (useExternalModal && onSentinelSelect) {
        // Use external modal
        if (formData.workType && formData.workType.id && workTypes.find(wt => wt.id === formData.workType.id)) {
          onSentinelSelect('edit', lookupField);
        } else {
          toast.current.show({
            severity: 'warn',
            summary: 'No Work Type Selected',
            detail: 'Please select a valid work type to edit.'
          });
        }
        return;
      }
      // Use built-in modal
      if (formData.workType && formData.workType.id && workTypes.find(wt => wt.id === formData.workType.id)) {
        openEditWorkType(formData.workType);
      } else {
        toast.current.show({
          severity: 'warn',
          summary: 'No Work Type Selected',
          detail: 'Please select a valid work type to edit.'
        });
      }
      return;
    }

    setFormData(prev => ({
      ...prev,
      workType: value,
      status: value?.statuses?.length > 0 ? value.statuses[0] : null
    }));

    // Notify parent of selection change
    if (onSelectionChange) {
      onSelectionChange(value);
    }
    return;
  }

  setFormData(prev => ({ ...prev, [field]: value }));
};


    const openCreateWorkType = () => {
        setEditingWorkType(null);
        setWorkTypeForm({ name: '', icon: '', color: '#4c9aff', description: '', statuses: ['To Do', 'In Progress', 'Done'] });
        // set current lookup to prop if provided
        if (lookupField) setCurrentLookupName(lookupField);
        // default selected lookup in modal
        setSelectedLookupName(lookupField || null);
        // if parent didn't provide initial list, set workTypes based on selected lookup
        if (!propInitialWorkTypes) {
            const key = lookupField || selectedLookupName || currentLookupName;
            if (key && lookupInitials[key]) {
                setWorkTypes(lookupInitials[key]);
                setFormData(prev => ({ ...prev, workType: lookupInitials[key][0] || null }));
            }
        }
        setWorkTypeModalVisible(true);
    };

    const openEditWorkType = (workType) => {
        const workTypeToEdit = workTypes.find(wt => wt.id === workType.id);
        if (workTypeToEdit) {
            setEditingWorkType(workTypeToEdit);
            setWorkTypeForm({ ...workTypeToEdit });
        } else {
            console.warn("Work type not found in workTypes array:", workType);
            setEditingWorkType(workType);
            setWorkTypeForm({ ...workType });
        }
        // if parent passed lookupField, prefer it; otherwise try to infer if the workType carries lookup name
        if (lookupField) {
            setCurrentLookupName(lookupField);
            setSelectedLookupName(lookupField);
        } else if (workType && typeof workType.name === 'string' && workType.name.startsWith('employee_')) {
            setCurrentLookupName(workType.name);
            setSelectedLookupName(workType.name);
        } else {
            setSelectedLookupName(null);
        }
        setWorkTypeModalVisible(true);
    };

    const handleEditWorkTypeDropdownChange = (selectedWorkType) => {
        setEditingWorkType(selectedWorkType);
        setWorkTypeForm({ ...selectedWorkType });
    };

    return (
        <div className="p-0">
            <style>{customStyles}</style>
            <Toast ref={toast} />
            <ConfirmDialog />

            <div className="formgrid grid p-fluid" style={{ maxWidth: '1000px', margin: 'auto' }}>
                <div className="field col-12 p-0 mb-0">
                    {/* <label htmlFor="workType" className="mb-2">
                        Work type <span className="text-red-500">*</span>
                    </label> */}
                    <Dropdown
                        id="workType"
                        value={formData.workType}
                        options={dropdownWorkTypes}
                        placeholder="Select"
                        onChange={(e) => handleInputChange('workType', e.value)}
                        optionLabel="name"
                        itemTemplate={workTypeOptionTemplate}
                        valueTemplate={workTypeOptionTemplate}
                        className="w-full bgclr"
                        optionDisabled={(option) => option.disabled === true}
                        scrollHeight="250px"
                        appendTo={document.body}
                        style={{ border: '1px solid #d2d2d2' }}
                        panelStyle={{
                            maxHeight: '250px',
                            overflow: 'hidden'
                        }}
                    />
                </div>
            </div>

            <Dialog
                header={editingWorkType ? "Edit Work Type" : "Add Work Type"}
                visible={workTypeModalVisible}
                style={{ width: '450px' }}
                onHide={() => setWorkTypeModalVisible(false)}
                modal
            >
                <div className="formgrid grid p-fluid work-type-modal">
                    {editingWorkType ? (
                        <>
                            <div className="field col-12 mb-3">
                                <small className="text-500">
                                    Required fields are marked with an asterisk <span className="text-red-500">*</span>
                                </small>
                            </div>
                            <div className="field col-12">
                                <label htmlFor="workTypeToEdit" className="block text-900 font-medium mb-2">
                                    Work type to edit
                                </label>
                                <Dropdown
                                    id="workTypeToEdit"
                                    value={editingWorkType}
                                    options={workTypes}
                                    onChange={(e) => handleEditWorkTypeDropdownChange(e.value)}
                                    placeholder="Select to edit"
                                    optionLabel="name"
                                    itemTemplate={workTypeOptionTemplate}
                                    valueTemplate={workTypeOptionTemplate}
                                    className="w-full bgclr"

                                />
                            </div>
                            <div className="field col-12">
                                <label htmlFor="workTypeName" className="block text-900 font-medium mb-2">
                                    Work type name <span className="text-red-500">*</span>
                                </label>
                                <InputText
                                    id="workTypeName"
                                    value={workTypeForm.name}
                                    onChange={(e) => setWorkTypeForm(prev => ({ ...prev, name: e.target.value }))}
                                    placeholder="Enter work type name"
                                    className="w-full"
                                />
                            </div>
                            <div className="field col-12">
                                <label htmlFor="workTypeDescription" className="block text-900 font-medium mb-2">
                                    Description
                                </label>
                                <InputTextarea
                                    id="workTypeDescription"
                                    value={workTypeForm.description}
                                    onChange={(e) => setWorkTypeForm(prev => ({ ...prev, description: e.target.value }))}
                                    placeholder="Let people know when to use this work type."
                                    rows={3}
                                    className="w-full"
                                />
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="field col-12">
                                <label htmlFor="lookupFor" className="block text-900 font-medium mb-2">Lookup For</label>
                                <Dropdown
                                    id="lookupFor"
                                    value={selectedLookupName}
                                    options={lookupOptions}
                                    onChange={(e) => setSelectedLookupName(e.value)}
                                    optionLabel="label"
                                    optionValue="value"
                                    placeholder="Select lookup target"
                                    className="w-full bgclr"
                                />
                            </div>
                            <div className="field col-12">
                                <label htmlFor="workTypeName" className="block text-900 font-medium mb-2">
                                    Work type name <span className="text-red-500">*</span>
                                </label>
                                <InputText
                                    id="workTypeName"
                                    value={workTypeForm.name}
                                    onChange={(e) => setWorkTypeForm(prev => ({ ...prev, name: e.target.value }))}
                                    placeholder="Enter work type name"
                                    className="w-full"
                                />
                            </div>
                            <div className="field col-12">
                                <label htmlFor="workTypeDescription" className="block text-900 font-medium mb-2">
                                    Description
                                </label>
                                <InputTextarea
                                    id="workTypeDescription"
                                    value={workTypeForm.description}
                                    onChange={(e) => setWorkTypeForm(prev => ({ ...prev, description: e.target.value }))}
                                    placeholder="Let people know when to use this work type."
                                    rows={3}
                                    className="w-full"
                                />
                            </div>
                        </>
                    )}
                </div>

                <div className="p-dialog-footer flex justify-content-end gap-2">
                    <Button
                        label="Cancel"
                        className="p-button-secondary"
                        onClick={() => setWorkTypeModalVisible(false)}
                    />
                    <Button
                        label={editingWorkType ? "Save" : "Create"}
                        className="p-button-primary"
                        onClick={saveWorkType}
                    />
                </div>
            </Dialog>

            <Dialog
                header="Choose an icon"
                visible={iconPickerVisible}
                style={{ width: '500px' }}
                onHide={() => setIconPickerVisible(false)}
                modal
            >
                <div className="flex flex-column gap-3">
                    <div className="field">
                        <div className="icon-upload-area flex flex-column align-items-center justify-content-center gap-3">
                            <i className="pi pi-cloud-upload text-5xl text-400"></i>
                            <span className="text-lg text-600">Drag and drop your images here</span>
                            <span className="text-500">or</span>
                            <FileUpload
                                mode="basic"
                                name="iconUpload"
                                accept="image/*"
                                maxFileSize={1000000}
                                auto={false}
                                chooseLabel="Upload a photo"
                                onSelect={onWorkTypeIconUpload}
                                className="p-button-sm"
                            />
                        </div>
                    </div>

                    <div className="field">
                        <label className="block text-900 font-medium mb-2">Suggested Icons</label>
                        <div className="icon-picker-grid">
                            {predefinedIcons.map((item, index) => (
                                <div
                                    key={index}
                                    className={`icon-picker-item ${item.value === workTypeForm.icon ? 'selected' : ''}`}
                                    onClick={() => selectIcon(item.value)}
                                >
                                    {item.value.startsWith('pi pi-') ? (
                                        <i className={`${item.value} text-2xl`} style={{ color: item.color }}></i>
                                    ) : (
                                        <Avatar
                                            label={item.value}
                                            size="large"
                                            style={{ backgroundColor: item.color, color: 'white' }}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="p-dialog-footer flex justify-content-end gap-2">
                    <Button
                        label="Cancel"
                        className="p-button-secondary"
                        onClick={() => setIconPickerVisible(false)}
                    />
                    <Button
                        label="Select"
                        className="p-button-primary"
                        onClick={() => setIconPickerVisible(false)}
                    />
                </div>
            </Dialog>
        </div>
    );
};

export default WorkType1;